import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "@clerk/react";
import api from "../../services/Axios";
import LoadingScreen from "../../components/LoadingScreen";
import AccessDenied from "../../views/auth/AccessDenied";

const UserGuard = ({ children }) => {
  const { isLoaded, isSignedIn, getToken } = useAuth();
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    if (!isLoaded || !isSignedIn) {
      setAllowed(null);
      return undefined;
    }

    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/admin/me");
        if (!cancelled) setAllowed(data?.ok === true);
      } catch (err) {
        const status = err?.response?.status;
        if (status === 401) {
          try {
            await getToken({ skipCache: true });
            const { data } = await api.get("/admin/me");
            if (!cancelled) setAllowed(data?.ok === true);
            return;
          } catch {
            // still unauthorized
          }
        }
        if (!cancelled) setAllowed(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isLoaded, isSignedIn, getToken]);

  if (!isLoaded) {
    return <LoadingScreen />;
  }
  if (!isSignedIn) {
    return <Navigate to="/login" replace />;
  }
  if (allowed === null) {
    return <LoadingScreen />;
  }
  if (!allowed) {
    return <AccessDenied />;
  }
  return <>{children}</>;
};

UserGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UserGuard;
